import { instance, endpoint, isMock, generator } from 'api'
import { mocker } from 'api/warningmsg/mocker'

export default {
  getWarningmsg () {
    if (isMock) return generator(mocker.warningmsg())
    return instance().get(endpoint + '/warnmsg/detail')
  }
}



// WEBPACK FOOTER //
// ./src/api/warningmsg/index.js